/* VP Motiv Engine „flach" (21.09.2026, Aufgabe 1).
   Der heutige Customizer: Logo und Text auf eine rechteckige Druckflaeche ueber dem Produktfoto, mit Verschieben, Drehen, Einrasten und Vorschau.

   WICHTIG: Diese Datei enthaelt keine Logik. Die Engine flach ist der Code, der unveraendert in assets/vp-konfigurator.js steht
   (Abschnitte Werkbank, Druckfarben, Werkzeuge) und auf der Geometrie in assets/vp-konfigurator-core.js aufsetzt.
   Der Code wurde bewusst NICHT herausgeloest: Werkbank und uebrige Abschnitte teilen sich einen Closure Scope, ueber die Grenze laufen
   21 Bindungen hinein und 12 heraus. Ein Herausloesen braeuchte eine neu erfundene Schnittstelle fuer 33 Namen und waere kein reines
   Verschieben mehr — damit waere die Abnahmebedingung (XD Connects und midocean verhalten sich unveraendert) nicht mehr belegbar.
   Befund, die 33 Bindungen und die Aufteilung fuer Schritt zwei: docs/customizer/VERPACKUNG.md und docs/customizer/MOTIV-ENGINES.md.

   Diese Datei meldet die Engine nur an, damit der Dispatcher in sections/vp-konfigurator.liquid und die spaetere Engine verpackung
   einen gemeinsamen Anlaufpunkt haben. Sie darf das Verhalten des Konfigurators nicht beeinflussen. */
window.VPMotivEngines = window.VPMotivEngines || {};
window.VPMotivEngines.flach = {
  name: 'flach',
  label: 'Motiv gestalten',
  /* Die Umsetzung liegt in assets/vp-konfigurator.js und startet dort mit dem Konfigurator selbst. */
  implementiertIn: 'vp-konfigurator.js',
  eigenstaendig: false,
};
